var _path, _ellipse, _path2, _rect, _rect2, _circle, _path3, _path4, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _circle2, _path5, _circle3, _path6, _path7, _path8, _path9, _path10, _circle4, _path11, _ellipse7, _path12, _rect3, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _circle5, _path23;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoveIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fbf61bc7-949a-4ad5-bdf9-42522344582c",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 1035.47998,
    height: 627.63641,
    viewBox: "0 0 1035.47998 627.63641",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "spread_love") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M769.26,350.83035,418.42291,136.18179l-53.38806,87.26136a65.99058,65.99058,0,0,1-68.85449,112.54071l-17.32489,28.31707H426.74V543.37424l360.30951,220.444,75.411-123.25727H769.26Z",
    transform: "translate(-82.26001 -136.18179)",
    fill: "#f2f2f2"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 514.42442,
    cy: 470.26294,
    rx: 63.53704,
    ry: 9.82156,
    fill: "#6415ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M598.74,519.461l64.01782-73.23435a51,51,0,0,0-72.91512-71.32591,51,51,0,1,0-71.32591,72.91512L589.74,519.461",
    transform: "translate(-82.26001 -136.18179)",
    fill: "#6415ff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 227.11914,
    width: 345.47998,
    height: 313.26001,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 689,
    y: 190.11914,
    width: 345.47998,
    height: 313.26001,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 249.47998,
    cy: 144.27917,
    r: 43,
    fill: "#6415ff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M433.74,514.461s54-19,77,7,87-15,87-15",
    transform: "translate(-82.26001 -136.18179)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M872.74,521.461s-10-24-78-2-164,21-188-13l64.01782-73.23435a51,51,0,0,0-72.91512-71.32591,51,51,0,1,0-71.32591,72.91512L597.74,506.461",
    transform: "translate(-82.26001 -136.18179)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 522.53554,
    cy: 462.10074,
    rx: 63.53704,
    ry: 9.82156,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 515.77628,
    cy: 531.19233,
    rx: 50.01852,
    ry: 7.73187,
    fill: "#6415ff"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 515.77628,
    cy: 590.05494,
    rx: 33.7963,
    ry: 5.22424,
    fill: "#6415ff"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 522.53554,
    cy: 524.30398,
    rx: 50.01852,
    ry: 7.73187,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 522.53554,
    cy: 584.8703,
    rx: 33.7963,
    ry: 5.22424,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 202.5984,
    cy: 357.48372,
    r: 33.25222,
    fill: "#2f2e41"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M268.98505,510.46481s-10.83083,23.98257-13.92536,24.7562,25.52983,14.699,25.52983,14.699,5.41542-29.398,7.73631-30.94525S268.98505,510.46481,268.98505,510.46481Z",
    transform: "translate(-82.26001 -136.18179)",
    fill: "#9f616a"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 202.9713,
    cy: 369.64123,
    r: 22.4353,
    fill: "#9f616a"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M304.02,676.56094h-95.4c3.19-11.59,6.6-23.08,8.52-29.46.97-3.2,1.56-5.12005,1.56-5.12005s71.95,15.47,73.49,16.25a18.22647,18.22647,0,0,1,2.29,3.02C296.73,664.55093,300.32,670.221,304.02,676.56094Z",
    transform: "translate(-82.26001 -136.18179)",
    fill: "#2f2e41"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M185.43289,457.85789l-23.20894-35.587s5.73939-37.33115-1.99692-30.36847-10.18455,35.08012-10.18455,35.08012l26.88046,40.93259Z",
    transform: "translate(-82.26001 -136.18179)",
    fill: "#9f616a"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M395.86057,522.84291l20.888-1.54726s24.7562-26.30346,26.30346-17.79352-20.11441,27.07709-20.11441,27.07709l-28.62435,3.09452Z",
    transform: "translate(-82.26001 -136.18179)",
    fill: "#9f616a"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M243.45522,530.57922v-7.73631s-20.11441-13.15173-19.34077-15.47263-1.54727-3.86815-1.54727-3.86815-2.32089-3.09453-2.32089-3.86816-3.09453-1.54726-3.09453-1.54726L197.811,475.65141s-10.83084-21.66168-13.15173-20.88805-14.699,5.41542-13.15173,8.51,44.8706,69.6268,44.8706,69.6268,2.3209,14.699,6.18905,14.699S243.45522,530.57922,243.45522,530.57922Z",
    transform: "translate(-82.26001 -136.18179)",
    fill: "#3f3d56"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M295.28851,539.86279s17.01989-.77363,17.79352,0,11.60447,0,11.60447,0,29.398-6.96268,31.71888-9.28357,41.00245-12.3781,42.54971-7.73631,5.41542,13.92536,1.54726,15.47262S292.194,566.16625,292.194,566.16625Z",
    transform: "translate(-82.26001 -136.18179)",
    fill: "#3f3d56"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 190.9663,
    cy: 322.48602,
    r: 13.75954,
    fill: "#2f2e41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M254.88025,451.21473a13.761,13.761,0,0,1,12.32626-13.68515,13.91485,13.91485,0,0,0-1.43329-.07439,13.75954,13.75954,0,1,0,0,27.51908,13.912,13.912,0,0,0,1.43329-.07439A13.761,13.761,0,0,1,254.88025,451.21473Z",
    transform: "translate(-82.26001 -136.18179)",
    fill: "#2f2e41"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 206.46656,
    cy: 350.43337,
    rx: 22.93257,
    ry: 13.75954,
    fill: "#2f2e41"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M262.40919,522.45609s-6.96268,5.41542-8.50994,6.189-10.83084-6.96268-12.3781-6.96268-21.66168,23.20894-21.66168,23.20894,3.73809,4.30569,0,26.30346c-1.40189,8.24983-4.18323,43.52067-4.18323,48.16246s-15.15755,16.04893-1.23218,26.10613,80.45764,20.888,81.23127,14.699-7.73631-22.4353-3.86816-30.17161,3.86816-36.36067,3.86816-36.36067l4.64179-30.17161,3.86815-23.98257s-18.18033-5.0286-19.72759-5.0286S275.94773,545.27821,262.40919,522.45609Z",
    transform: "translate(-82.26001 -136.18179)",
    fill: "#3f3d56"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 944.10581,
    y: 448.86585,
    width: 15.84263,
    height: 20.3691,
    transform: "translate(-99.33277 -98.94691) rotate(-2.22071)",
    fill: "#6415ff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M888.1355,519.85005s-21.92306-10.47453-21.57226-1.4284,22.09845,14.9976,22.09845,14.9976Z",
    transform: "translate(-82.26001 -136.18179)",
    fill: "#ffb9b9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M990.08,639.56094H886.09c2.17-10.18,6.3-22.46,9.53-31.31,2.56-7,4.54-11.86,4.54-11.86,11.81-13.32,28.95-13.66,45.03-10.37,1.92.39,3.83.83,5.71,1.32.22.05.44.11.66.17,3.76.97,7.41,2.09,10.86,3.21,5.95,1.94,11.32,3.9,15.66,5.23a38.58592,38.58592,0,0,0,6.7,1.57,11.37386,11.37386,0,0,0,1.5.06c1.72-.07,2.91,1.78,3.68,5.01C991.7,609.881,991.3,624.24094,990.08,639.56094Z",
    transform: "translate(-82.26001 -136.18179)",
    fill: "#2f2e41"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M969.56663,429.49234s12.0531,18.78454,16.75156,23.13221-8.51994,13.92-8.51994,13.92l-23.6584,3.18237s.29763-21.52842-.92083-23.7461S969.56663,429.49234,969.56663,429.49234Z",
    transform: "translate(-82.26001 -136.18179)",
    fill: "#ffb9b9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M949.00289,454.07157s4.87386,8.87074,9.39693,8.69534,27.91837-10.14236,28.91759-13.57851,7.74928,24.61377,7.74928,24.61377L937.82016,574.54673,923.85632,564.896l6.766-59.15067,5.55683-31.92456Z",
    transform: "translate(-82.26001 -136.18179)",
    fill: "#6415ff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M989.429,544.23376a31.67948,31.67948,0,0,0-3.512,14.85826c.00877.22617.01754.45226.03762.678.54173,10.46565,4.39716,22.56945,5.78035,31.37171,1.00365,6.3142.718,10.92309-2.97709,12.00635-8.95844,2.61233,1.30616,4.47922-33.353,16.01544s-40.7076,1.57857-40.7953-.683,4.9084-19.44228,3.73379-20.5292-16.43532,14.22694-21.04608,12.1408-.52619-13.5692-.52619-13.5692,10.38684-24.18459,10.16759-29.83842,15.73373-32.31921,15.73373-32.31921L933.523,463.73159s4.17228-9.22153,9.78226-10.57154a13.8973,13.8973,0,0,1,10.2646,1.86689l-9.38762,20.74844-9.9045,36.623,1.657,13.52535s11.5176-24.22844,19.08218-33.58152,23.69294-31.49538,23.69294-31.49538,3.76541-12.70511.9229-16.5019c-2.84295-3.80805,11.857-4.37809,18.12474,11.2334,3.32192,8.27407,8.71525,20.61268,12.09386,32.10079,3.01066,10.17734,4.43279,19.69155,1.45011,25.12982C1006.74261,521.11686,995.27516,532.03687,989.429,544.23376Z",
    transform: "translate(-82.26001 -136.18179)",
    fill: "#575a89"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1011.30138,512.809c-4.55877,8.30789-16.02622,19.2279-21.87243,31.42479-1.527-5.50124-3.38977-11.19323-3.38977-11.19323s-7.1447-38.22682,13.98907-48.10608a14.144,14.144,0,0,1,9.823,2.7447C1012.86193,497.85649,1014.28406,507.3707,1011.30138,512.809Z",
    transform: "translate(-82.26001 -136.18179)",
    opacity: 0.1
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M927.40539,510.4l-17.91687,5.22465-24.87686.96468-2.55917,21.61611,40.883,2.9445S933.14693,512.44226,927.40539,510.4Z",
    transform: "translate(-82.26001 -136.18179)",
    fill: "#575a89"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M956.62134,583.08013s-23.96919,3.97672-18.49848,11.18969,26.70454-.37023,26.70454-.37023Z",
    transform: "translate(-82.26001 -136.18179)",
    fill: "#ffb9b9"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M985.95456,559.77c.54173,10.46565,4.39716,22.56945,5.78035,31.37171-7.63569,7.22679-14.89678,13.601-17.63321,13.70716-5.65383.21924-14.74382-.56073-18.09227.70158s-5.31235-20.1784-5.31235-20.1784,1.99844-6.8723,10.913-10.6154C967.62726,572.22439,979.16121,565.35605,985.95456,559.77Z",
    transform: "translate(-82.26001 -136.18179)",
    opacity: 0.1
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M999.76516,478.14985s19.13533-3.007,18.10157,28.74219,2.01706,52.01527-5.67906,57.97605S979.49244,597.845,973.8386,598.06428s-14.74381-.56073-18.09226.70158-5.31235-20.1784-5.31235-20.1784,1.99844-6.8723,10.913-10.6154,29.91682-17.01465,29.74142-21.53772-5.31235-20.17841-5.31235-20.17841S978.63138,488.02911,999.76516,478.14985Z",
    transform: "translate(-82.26001 -136.18179)",
    fill: "#575a89"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 870.43282,
    cy: 296.22981,
    r: 24.89557,
    fill: "#ffb9b9"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M935.93,396.729a4.807,4.807,0,0,1-2.09325,1.05045,1.49374,1.49374,0,0,1-1.731-1.19907,6.2065,6.2065,0,0,1-2.37516,3.04631c-1.16293.60612-2.96116.09787-3.12878-1.20277a5.48871,5.48871,0,0,1-1.26332,2.66669,1.89208,1.89208,0,0,1-2.65991.08891c.50929,2.78318.19495,5.64539.35488,8.47025s.91321,5.81964,3.04744,7.67718c3.11255,2.709,7.79306,2.04043,11.88736,1.52719a3.60813,3.60813,0,0,1,1.86287.10191c1.533.65313,1.46349,2.7872,1.48416,4.45344a12.37417,12.37417,0,0,0,10.83526,11.75074,6.20294,6.20294,0,0,0,4.61016-1.12514c1.16247-.98533,1.75626-2.59129,3.08831-3.33148,2.16679-1.204,4.79469.55192,6.3789,2.45847s3.14555,4.25181,5.5997,4.60081c3.24577.46157,5.7179-2.84623,6.93077-5.892a34.34808,34.34808,0,0,0-.68262-26.68876C971.29851,390.40876,948.14727,388.07207,935.93,396.729Z",
    transform: "translate(-82.26001 -136.18179)",
    fill: "#2f2e41"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoveIllustration);
export default __webpack_public_path__ + "static/media/love-illustration.c759090fa833369ad6ffb6eb19cacb3e.svg";
export { ForwardRef as ReactComponent };